import { render, staticRenderFns } from "./clientEmployersList.vue?vue&type=template&id=42c06a69&scoped=true"
import script from "./clientEmployersList.vue?vue&type=script&lang=js"
export * from "./clientEmployersList.vue?vue&type=script&lang=js"
import style0 from "./clientEmployersList.vue?vue&type=style&index=0&id=42c06a69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c06a69",
  null
  
)

export default component.exports